function showContent(el, index) {
    const hiddenContent = document.querySelector(".lf-piti-content-container:not(.lf-none)");
    const activeTitle = document.querySelector('.lf-piti-title.lf-active-title');
    const content = document.getElementById(`content-${index}`);
    const image = el.dataset.image;

    activeTitle.classList.remove('lf-active-title');
    el.classList.add('lf-active-title');

    hiddenContent.classList.add('lf-none');
    content.classList.remove('lf-none');

    if (image) {
      const section = content.closest(".lf-section-product-info-tabs-image");
      const imageContainer = section.querySelector(".lf-piti-img-container img");
      imageContainer.src = image
      imageContainer.srcset = image;
    }
}
